import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const sharedClasses = 'relative group overflow-hidden rounded-sm bg-gradient-to-b from-gold-400 to-gold-600 px-8 py-4 font-sans font-bold text-navy-950 shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] border border-gold-400/50 w-full sm:w-auto inline-block text-center no-underline cursor-pointer';
  const inner = <>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-159" />
      <span className="relative z-10 flex items-center justify-center gap-2 tracking-wide uppercase text-sm sm:text-base" data-id="element-160">
        {children}
      </span>
    </>;
  return <div className={`relative inline-block ${className}`} data-id="element-161">
      {/* Outer glow effect */}
      <div className="absolute -inset-1 rounded-sm bg-gold-500/40 blur-xl opacity-50 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse" data-id="element-162" />

      {href ? <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className={sharedClasses} data-id="element-163">
          {inner}
        </motion.a> : <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className={sharedClasses} data-id="element-164">
          {inner}
        </motion.button>}
    </div>;
}